import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { NiceModalActions } from '@web-common/state/reducer';
import { apiHolder as api, apis, } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { isMainAccount } from '@web-mail/util';
import { getIn18Text } from 'api';
const InitialState = {
    signList: [],
    signListOther: [],
    signTemplates: [],
    signPriviewContent: '',
    signListLoading: false,
    signListOtherLoading: false,
    signActionLoading: false,
    signPreviewModalVisible: false,
    signContent: '',
    signItem: null,
    errMsg: '',
    defaultAvatar: '',
    mailTemplateContent: [],
    hasContent: false,
    currentMail: '',
    nickname: '',
    displayMail: '',
};
const signatureApi = api.api.requireLogicalApi(apis.mailSignatureImplApi);
const REDUCER_NAME_SPACE = 'mailConfigReducer';
export const getSignTemplatesAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/getSignTemplate`, async (params, { rejectWithValue, getState }) => {
    const { currentMail } = getState().mailReducer;
    const defAccount = currentMail.optSender;
    const curAccountEmail = (params === null || params === void 0 ? void 0 : params.email) || (defAccount === null || defAccount === void 0 ? void 0 : defAccount.mailEmail);
    const res = await signatureApi.doGetSignTemplateAndProfile(undefined, curAccountEmail);
    return (res === null || res === void 0 ? void 0 : res.success) ? res.data : rejectWithValue(getIn18Text('HUOQUQIANMINGMO'));
});
export const previewSignAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/previewSign`, async (param, { rejectWithValue, dispatch, getState }) => {
    var _a, _b;
    dispatch(mailConfigSlice.actions.doToggleSignPreviewModal(true));
    const { signTemplateId } = param.signInfo || {};
    const { signContent } = getState().mailConfigReducer;
    if (signTemplateId === 0) {
        return signContent;
    }
    const { currentMail } = getState().mailReducer;
    const res = await signatureApi.doGetSignPreview(param, (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender) === null || _a === void 0 ? void 0 : _a.id);
    if (res.success) {
        return ((_b = res.data) === null || _b === void 0 ? void 0 : _b.divHtml) || '';
    }
    return rejectWithValue(getIn18Text('YULANQIANMINGSHI'));
});
const reGetSignListAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/reGetSignList`, async (params, { dispatch, getState }) => {
    const { currentMail } = getState().mailConfigReducer;
    const curAccountEmail = params === null || params === void 0 ? void 0 : params.email;
    if (isMainAccount(curAccountEmail) || !currentMail) {
        await dispatch(getSignListAsync({ email: curAccountEmail }));
    }
    else {
        await dispatch(getSignListOtherAsync({ email: curAccountEmail }));
    }
});
export const getSignListAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/getSignList`, async (params, { rejectWithValue, getState }) => {
    var _a;
    const { currentMail } = getState().mailReducer;
    const defAccount = currentMail.optSender;
    const curAccountEmail = (params === null || params === void 0 ? void 0 : params.email) === undefined ? defAccount === null || defAccount === void 0 ? void 0 : defAccount.mailEmail : params === null || params === void 0 ? void 0 : params.email;
    const res = await signatureApi.doGetSignList({}, curAccountEmail);
    if (res === null || res === void 0 ? void 0 : res.success) {
        (_a = res.data) === null || _a === void 0 ? void 0 : _a.map(sign => {
            sign._account = curAccountEmail || '';
        });
        return res.data;
    }
    return rejectWithValue(getIn18Text('HUOQUQIANMINGLIE'));
});
export const getSignListOtherAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/getSignListOther`, async (params, { rejectWithValue, getState }) => {
    var _a;
    const curAccountEmail = params === null || params === void 0 ? void 0 : params.email;
    const res = await signatureApi.doGetSignList({}, curAccountEmail);
    if (res === null || res === void 0 ? void 0 : res.success) {
        (_a = res.data) === null || _a === void 0 ? void 0 : _a.map(sign => {
            sign._account = curAccountEmail || '';
        });
        return res.data;
    }
    return rejectWithValue(getIn18Text('HUOQUQIANMINGLIE'));
});
export const addSignAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/addSign`, async (param, { dispatch, rejectWithValue }) => {
    const currentAccount = param._account || '';
    const reqParams = Object.assign({}, param);
    delete reqParams._account;
    delete reqParams.isDefault;
    delete reqParams.isSetDefault;
    delete reqParams.modalId;
    const res = await signatureApi.doAddSign(reqParams, currentAccount);
    if (res.success) {
        dispatch(NiceModalActions.hideModal({ modalId: param.modalId }));
        await dispatch(reGetSignListAsync({ email: currentAccount }));
        return true;
    }
    const errMsg = getIn18Text('XINZENGQIANMINGSHI');
    message.error({ content: errMsg });
    dispatch(reGetSignListAsync({ email: currentAccount }));
    return rejectWithValue(errMsg);
});
export const editSignAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/editSign`, async (param, { dispatch, rejectWithValue }) => {
    const currentAccount = param._account || '';
    const reqParams = Object.assign({}, param);
    delete reqParams._account;
    reqParams.isDefault = [];
    delete reqParams.isDefault;
    delete reqParams.isSetDefault;
    delete reqParams.modalId;
    const res = await signatureApi.doUpdateSign(reqParams, currentAccount);
    if (res.success) {
        dispatch(NiceModalActions.hideModal({ modalId: param.modalId }));
        dispatch(reGetSignListAsync({ email: currentAccount }));
        return true;
    }
    const errMsg = getIn18Text('BAOCUNQIANMINGSHI');
    message.error({ content: errMsg });
    dispatch(reGetSignListAsync({ email: currentAccount }));
    return rejectWithValue(errMsg);
});
export const deleteSignAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/deleteSign`, async ({ id, refresh = true, _account = '', }, { dispatch, rejectWithValue, getState }) => {
    const result = await signatureApi.doDeleteSign(id, _account);
    if (result.success) {
        refresh && dispatch(reGetSignListAsync({ email: _account }));
        return result.data;
    }
    const errMsg = getIn18Text('SHANCHUQIANMINGSHI');
    message.error({ content: errMsg });
    dispatch(reGetSignListAsync({ email: _account }));
    return rejectWithValue(errMsg);
});
export const useSignAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/useSign`, async (param, { dispatch, rejectWithValue }) => {
    const currentAccount = param._account || '';
    const reqParams = Object.assign({}, param);
    delete reqParams._account;
    const res = await signatureApi.doSetDefaultSign(reqParams, currentAccount);
    if (res.success) {
        dispatch(reGetSignListAsync({ email: currentAccount }));
        return res.data;
    }
    const errMsg = getIn18Text('JIEKOUDIAOYONGSHI');
    message.error({ content: errMsg });
    dispatch(reGetSignListAsync({ email: currentAccount }));
    return rejectWithValue(errMsg);
});
const validateCRUDAction = (type) => isAnyOf(useSignAsync[type], deleteSignAsync[type], editSignAsync[type], addSignAsync[type], getSignTemplatesAsync[type], previewSignAsync[type]);
const mailConfigSlice = createSlice({
    name: REDUCER_NAME_SPACE,
    initialState: InitialState,
    reducers: {
        doChangeContent: (state, action) => {
            state.signContent = action.payload;
        },
        doToggleSignPreviewModal: (state, action) => {
            state.signPreviewModalVisible = action.payload;
        },
        doSetHasContent: (state, action) => {
            state.hasContent = action.payload;
        },
        doSetCurrentMail: (state, action) => {
            state.currentMail = action.payload;
        },
        doSetNickname: (state, action) => {
            state.nickname = action.payload;
        },
        doSetDisplayMail: (state, action) => {
            state.displayMail = action.payload;
        },
        doSetSignList: (state, action) => {
            if (action.payload) {
                state.signList = action.payload;
            }
        },
        doSetSignListOtherMap: (state, action) => {
            state.signListOther = action.payload;
        },
        doSetSignListLoading: (state, action) => {
            state.signListLoading = !!action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getSignListAsync.pending, state => {
            state.signListLoading = true;
        })
            .addCase(getSignListAsync.fulfilled, (state, action) => {
            state.signContent = '';
            state.signListLoading = false;
            state.signItem = null;
            if (!action.payload)
                return;
            state.signList = action.payload;
        })
            .addCase(getSignListAsync.rejected, (state, action) => {
            state.signListLoading = false;
        })
            .addCase(getSignListOtherAsync.pending, state => {
            state.signListOtherLoading = true;
        })
            .addCase(getSignListOtherAsync.fulfilled, (state, action) => {
            state.signListOtherLoading = false;
            if (!action.payload)
                return;
            state.signListOther = action.payload;
        })
            .addCase(getSignListOtherAsync.rejected, (state, action) => {
            state.signListOtherLoading = false;
        })
            .addCase(getSignTemplatesAsync.fulfilled, (state, action) => {
            const { profile = '', templatePics = [] } = action.payload || {};
            state.signTemplates = templatePics || [];
            state.defaultAvatar = profile;
        })
            .addCase(previewSignAsync.fulfilled, (state, action) => {
            state.signPriviewContent = action.payload || '';
        })
            .addMatcher(validateCRUDAction('pending'), state => {
            state.signActionLoading = true;
        })
            .addMatcher(validateCRUDAction('fulfilled'), state => {
            state.signActionLoading = false;
        })
            .addMatcher(validateCRUDAction('rejected'), state => {
            state.signActionLoading = false;
        });
    },
});
export const { actions } = mailConfigSlice;
export default mailConfigSlice.reducer;
